import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { ImportedContract } from 'modules/employees/pages/ImportContractsPage/components/ImportTable/Content/types'

interface Props {
  selectedContracts: ImportedContract[]
  onClickImport: () => void
}

const ImportButton = ({ selectedContracts, onClickImport }: Props) => {
  const count = selectedContracts.length
  const disabledLabel = i18n.t('import_contract.import_valid.zero')

  const enabledLabel = i18n.tp('import_contract.import_valid', {
    count,
  })

  return (
    <Button disabled={!count} onClick={onClickImport}>
      {!count ? disabledLabel : enabledLabel}
    </Button>
  )
}

export default observer(ImportButton)
